export enum StoreRetailSubscriptionEnum {
    NotParticipating = 14,
    Participating = 15
}

export enum RetailSubscriptionMessages {
    Error_while_retriving_data_from_Retail_Subscription_History = "Error while retriving data from Retail Subscription History",
    failureMessage = "failureMessage",
    successMessage = "successMessage"
}

export enum RetailSubscriptionErrorMessages{
    CHARGEBEE_ERROR="Chargebee Error"
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/retail-subscription.enum.ts